import { useMutation, useQueryClient } from '@tanstack/react-query';
import { TasksApi } from '../../../apis/TasksApi/TasksApi.ts';
import { QueryKeys } from '../../../queryDefaults/QueryKeys.ts';
import { Task } from '../Tasks.ts';
import { useSessionProvider } from '../../../provider/sessionContext.tsx';

function updateTasksCache(
    queryClient: ReturnType<typeof useQueryClient>,
    taskId: string,
    displayName: string | undefined
) {
    const updateTasks = (oldTasks: Task[] | undefined) => {
        if (!oldTasks) return oldTasks;
        return oldTasks.map((task) => {
            if (task.id === parseInt(taskId)) {
                return {
                    ...task,
                    lastReminderSentDate: new Date(),
                    lastReminderSentBy: displayName || null,
                };
            }
            return task;
        });
    };

    // Update all task-related queries that start with the tasks key
    queryClient.setQueriesData<Task[]>(
        { queryKey: [QueryKeys.tasks], exact: false },
        updateTasks
    );
}

export function useClientTaskReminder() {
    const queryClient = useQueryClient();
    const { currentUser } = useSessionProvider();

    return useMutation<void, Error, { taskId: string }>({
        mutationFn: async ({ taskId }) => {
            await TasksApi.sendReminderToUser(taskId);
        },
        onSuccess: (_, { taskId }) => {
            updateTasksCache(queryClient, taskId, currentUser?.displayName);
        },
    });
}

export function useAssistantTaskReminder() {
    const queryClient = useQueryClient();
    const { currentUser } = useSessionProvider();

    return useMutation<void, Error, { taskId: string }>({
        mutationFn: async ({ taskId }) => {
            await TasksApi.sendReminderToAssistant(taskId);
        },
        onSuccess: (_, { taskId }) => {
            updateTasksCache(queryClient, taskId, currentUser?.displayName);
        },
    });
}